import React from 'react';
import { Tabs } from 'antd';
import CustomerTab from './CustomerTab';
import '../../../pages/admin/admin_assets/css/common.css'
import EmployeeTab from './EmployeeTab';
import PartnerTab from './PartnerTab';
import InvestorTab from './InvestorTab';
function Template() {

    const onChange = (key) => {
        console.log(key);
      };

    const items = [
        {
          key: '1',
          label: 'Customer',
          children: <CustomerTab/>,
        },
        {
          key: '2',
          label: 'Employee',
          children: <EmployeeTab/>,
        },
        {
          key: '3',
          label: 'Partner',
          children: <PartnerTab/>,
        },
        {
            key: '4',
            label: 'Investor',
            children: <InvestorTab />,
        }
      ];

  return (
    <div className='container-fluid customer_template'>
        <h2 className='dashboard_heading'>Survey Template</h2>
        
        <Tabs defaultActiveKey="1" items={items} onChange={onChange}  />
    </div>
  )
}

export default Template
